import React, { useEffect, useMemo } from "react";
import {
  FormAutocomplete,
  formClasses,
  labelClasses,
  LabeledAutocomplete,
} from "../styles/AutocompleteStyles";
import { handleMUISelectEvent, toStandardCase } from "../utils/UtilFunctions";
import { Keys } from "../utils/Enum.keys";
import { TextField } from "@mui/material";
import { EMPTY_STRING } from "../utils/constants";
import { useLazyQuery } from "@apollo/client";
import useUrlParams from "../customHooks/useUrlParams";
import {
  GetTicketReasonsResult,
  GetTicketReasonsVar,
} from "../components/modules/asset/masters/ticketreason/queries/types";
import { GetTicketReasons } from "../components/modules/asset/masters/ticketreason/queries/queries";

interface Props {
  value: string;
  onChange: (newValue: string) => void;
  label?: string;
  disabled?: boolean;
}
const TicketReasonSelect = ({ value, onChange, label, disabled }: Props) => {
  const { customer_id } = useUrlParams();
  const [getTicketReasons, { data }] = useLazyQuery<
    GetTicketReasonsResult,
    GetTicketReasonsVar
  >(GetTicketReasons);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id) {
          getTicketReasons({
            variables: {
              customer_id,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [getTicketReasons, customer_id]);

  const options = useMemo(() => {
    if (data && data.GetTicketReasons) {
      return data.GetTicketReasons.map((item) => item.reason);
    } else {
      return [];
    }
  }, [data]);

  const commonAutocompleteProps = {
    className: label ? labelClasses.inputRoot : formClasses.inputRoot,
    openOnFocus: true,
    disabled: disabled,
    onChange: (e: React.SyntheticEvent<Element, Event>, value: unknown) =>
      onChange(value as string),
  };

  const commonTextFieldProps = {
    label: label || "",
    fullWidth: true,
    InputLabelProps: { shrink: label ? true : false },
    className: label
      ? labelClasses.formControlRoot
      : formClasses.formControlRoot,
  };

  const Autocomplete = label ? LabeledAutocomplete : FormAutocomplete;

  return (
    <Autocomplete
      {...commonAutocompleteProps}
      value={value}
      options={options}
      // Conditional value
      isOptionEqualToValue={(option) =>
        (option as string) === value || value === EMPTY_STRING
      }
      getOptionLabel={(option) =>
        toStandardCase(option as string).replaceAll("_", " ")
      }
      onKeyDown={(e) => {
        if (e.key === Keys.ENTER) {
          handleMUISelectEvent(e);
        }
      }}
      // autoComplete={false}
      renderInput={(params) => (
        <TextField
          {...params}
          {...commonTextFieldProps}
          autoComplete="one-time-code"
        />
      )}
    />
  );
};

export default TicketReasonSelect;
